<template>
  <div class="mx-auto flex w-full flex-col gap-4">
    <div class="flex flex-col gap-1">
      <h1 class="text-3xl font-bold tracking-tight">
        Checklists
      </h1>
      <p class="text-sm text-muted-foreground">
        Build reusable operational checklists and review execution progress item by item.
      </p>
    </div>

    <div class="rounded-md border p-4">
      <p class="text-sm text-muted-foreground">
        Total loaded checklists: <span class="font-semibold text-foreground">{{ items.length }}</span>
      </p>
    </div>

    <p v-if="errorMessage" class="text-sm text-destructive">
      {{ errorMessage }}
    </p>

    <div v-if="isLoading && items.length === 0" class="rounded-md border border-dashed p-4 text-sm text-muted-foreground">
      Loading checklists...
    </div>

    <p v-else-if="!isLoading && items.length === 0" class="rounded-md border border-dashed p-4 text-sm text-muted-foreground">
      No checklists available yet.
    </p>

    <div v-else class="flex flex-col gap-4">
      <Checklist v-for="checklist in items" :key="checklist.id" :checklist="checklist" />
    </div>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { computed, onMounted } from 'vue'
import Checklist from '../components/checklists/Checklist.vue'
import { useChecklistsStore } from '../stores/checklistsStore.js'

const checklistsStore = useChecklistsStore('index-page')
const { items, isLoading, error } = storeToRefs(checklistsStore)

const errorMessage = computed(() => {
  if (!error.value) {
    return null
  }

  return error.value.response?.data?.message ?? error.value.message ?? 'Unable to load checklists.'
})

onMounted(async () => {
  await checklistsStore.fetchItems({
    clear: true,
    not_paginated: true,
    order_by: 'started_at',
    order_direction: 'desc',
  })
})
</script>
